import { Job, JobCompanyInfo } from '@kanda-libs/ks-frontend-services';
import { SatNoteOpenBankingRequestBodyStruct } from '@kanda-libs/ks-frontend-services/src/service/external';

import { SatNoteFormQuestions } from './useOpenBankingSatNoteForm';

export const formatOpenBankingSatNoteBody = (
  formValues: SatNoteFormQuestions,
  job: Job,
  companyInfo: JobCompanyInfo,
): SatNoteOpenBankingRequestBodyStruct => ({
  job,
  companyInfo,
  satNote: {
    ...formValues.job.sat_note,
    q_availability: 'The installer told me when quoting me',
    q_application: 'I completed the application myself',
    q_advice: 'They just sent me a link to apply',
  },
  fingerprint: {
    value: formValues.acknowledged.value,
    ip: formValues.acknowledged.ip,
    timestamp: formValues.acknowledged.timestamp,
  },
});

export const getFileName = (job: Job, type: string): string =>
  `ideal4finance-job${job?.id ? `-${job.id}` : ''}-${type}.pdf`;
